"use client";
import { CommunityImpactCharts } from "@/components/Pages/Communities/Impact/ImpactCharts";

export default function ImpactPage() {
  return (
    <div className="flex flex-col gap-5">
      <CommunityImpactCharts />
    </div>
  );
}
